'use es6';

import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
export default styled(UIIcon).attrs(function () {
  return {
    name: 'sprocket',
    size: 24
  };
}).withConfig({
  displayName: "StyledSprocketIcon",
  componentId: "sc-73j9jw-0"
})(["vertical-align:sub;"]);